/**
 * HAWK DESIGN — uygulama girişi
 *
 * Bu dosya yalnızca sırayı kurar. Mantık `legacy/` altındaki modüllerde;
 * hepsi `window.*` üzerinden birbirini bulur, bu yüzden içe aktarma sırası
 * script etiketi sırasıyla birebir aynı olmak zorunda.
 *
 * jQuery + Bootstrap (public/vendor/plugin.js) paketleyiciye girmez;
 * index.html içinde klasik <script> olarak, bu modülden ÖNCE yüklenir.
 */

// Paketin çalıştığını index.html'deki emniyet bloğuna bildirir. O blok 8
// saniye sonra bu bayrağı göremezse belgeyi önbelleği atlayarak yeniden
// indirip sayfayı tazeliyor (bayat index.html kurtarması).
//
// Not: ES modüllerinde `import`lar hoist edilir, yani bu satır dosyanın
// başında olsa bile aşağıdaki tüm modüller çalıştıktan SONRA işlenir.
// İçe aktarmalardan biri hata fırlatırsa bayrak hiç konmaz — o durumda da
// uygulama zaten açılmamış demektir, bir kez yenilemek doğru davranış.
window.HAWK_PAKET_YUKLENDI = true;

// --- Arayüz sürüm anahtarı ---
// EN ÖNCE: HawkUIController kurucusunda eski mobil sihirbazın atlanabilmesi
// için bayrağın o modül çalışmadan önce yerinde olması gerekiyor.
import { v2Aktif } from './ui/flags';
import { panelleriKur } from './ui/sheet-controller';

// --- Stiller (Vite tek bir hash'li CSS dosyasında birleştirir) ---
// SIRA ÖNEMLİ:
//   tokens        : değişken tanımları, herkesten önce
//   bootstrap/style/arge : devralınan katmanlar
//   page          : sayfaya özel override'lar (index.html'den çıkarıldı)
//   touch-targets : Faz 2 — 44px dokunma hedefi düzeltmeleri
import './styles/tokens.css';
import './styles/bootstrap.min.css';
import './styles/style.css';
import './styles/arge.css';
import './styles/page.css';
import './styles/touch-targets.css';
import './styles/v2-layout.css';   // tamamı .ui-v2 altında kapsanmış

// --- Hawk modülleri — SIRA ÖNEMLİ ---
import './legacy/HawkLoader.js';          // window.hawkLoader
import './legacy/HawkUtils.js';           // window.hawkUtils
import './legacy/Hawk3DCore.js';          // window.hawk3D
import './legacy/HawkMaterialManager.js'; // window.hawkMaterials
import './legacy/HawkProductLogic.js';    // window.hawkProduct
import './legacy/HawkUIController.js';    // window.hawkUI
import './legacy/HawkCheckout.js';        // window.checkoutManager
import './legacy/HawkARManager.js';       // window.hawkAR

// --- Uygulamayı başlat ---
import './bootstrap.js';

// --- Faz 2 mobil düzeni (yalnızca anahtar açıkken çalışır) ---
// Statik import: dinamik import üst düzey await gerektiriyor, hedef
// tarayıcı listesi (safari14) bunu desteklemiyor. Modül zaten ~3 KB.
if (v2Aktif) panelleriKur();
